import React from 'react'
import { Col, Modal, Row } from 'react-bootstrap';

const ModalImageDocument = ({ show, path, onHide }) => {
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Imagenes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col className='text-center'><img src={path} className='img-fluid' /></Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default ModalImageDocument;